import React from 'react';
import format from 'date-fns/format';
import { isNumeric, date } from './utils';

const updateItemWithCurrentPort = function(visit, arrived, departed, index, ports) {
  if (arrived === null && departed === null) {
    visit.current = false;
    visit.visited = false;
  } else if (arrived !== null && departed !== null) {
    visit.current = false;
    visit.visited = true;
    ports.lastPortVisited = index;
  } else if (arrived !== null && departed === null) {
    visit.current = true;
    visit.visited = false;
    ports.currentPort = index;
    ports.lastPortVisited = null;
  }

  return ports;
};

const getCurrentPort = function(visitsDTO) {
  let ports = { lastPortVisited: null, currentPort: null };

  for (let i = 0; i < visitsDTO.length; i++) {
    const visit = visitsDTO[i];
    const arrived = visitsDTO[i].ATADate;
    const departed = visitsDTO[i].ATDDate;

    visit.current = false;
    visit.visited = false;

    ports = updateItemWithCurrentPort(visit, arrived, departed, i, ports);
  }

  return ports;
};

const prepareCurrentPorts = function(visitsDTO, ports, lang) {
  const v = [...visitsDTO];
  if (ports.lastPortVisited !== null) {
    if (visitsDTO.length >= ports.lastPortVisited + 1) {
      const inTransit = {
        inTransit: true,
        current: true,
        Port: 'In transit',
        OriginalETADate: '',
        OriginalETDDate: '',
        Separator: '',
        DepartureDate: '',
        ArrivalDate: ''
      };

      v.splice(ports.lastPortVisited + 1, 0, inTransit);
    }
  }

  return v;
};

const createDescriptionString = function(visitsDTO, ports, simpleView) {
  let status = '';

  let visit = null;
  let inTransit = false;

  if (ports.lastPortVisited !== null) {
    visit = visitsDTO[ports.lastPortVisited + 1];
    inTransit = true;
  } else {
    visit = visitsDTO[ports.currentPort];
  }

  if (!visit) {
    status = 'Arrival/departure unknown';
    //this.updateVesselStatus(status);
    return status;
  }

  const timeDiff = visit.Pool.Port.TimeZoneDiff;

  if (inTransit) {
    const ArrivalDate = visit.ATADate ? visit.ATADate : visit.ETADate;
    if (simpleView) {
      status = `Arrives in ${visit.Pool.Port.LocalName}, ${getDateAsString(
        ArrivalDate,
        timeDiff,
        simpleView
      )}`;
    } else {
      status = `Arrives in ${visit.Pool.Port.LocalName}, ${getDateAsString(
        ArrivalDate,
        timeDiff,
        simpleView
      )}`;
    }
  } else {
    const DepartureDate = visit.ATDDate ? visit.ATDDate : visit.ETDDate;

    if (simpleView) {
      status = `Departs ${visit.Pool.Port.LocalName}, ${getDateAsString(
        DepartureDate,
        timeDiff,
        simpleView
      )}`;
    } else {
      status = `Departs from ${visit.Pool.Port.LocalName}, ${getDateAsString(
        DepartureDate,
        timeDiff,
        simpleView
      )}`;
    }
  }

  //this.updateVesselStatus(status);
  return status;
};

const adjustForTimezoneAndRoundToHour = function(dateObj, timeZoneDiff) {
  let dateLocal = new Date(dateObj);

  if (timeZoneDiff) {
    const timeOffsetInMS = timeZoneDiff * 1000 * 60 * 60;
    dateLocal.setTime(dateLocal.getTime() + timeOffsetInMS);
  }

  return date.roundToHour(dateLocal);
};

const getDateAsString = function(date, timeDiff, simpleView) {
  const dateWithTimeDiff = adjustForTimezoneAndRoundToHour(date, timeDiff);

  if (simpleView) {
    return format(dateWithTimeDiff, 'DD.MM - HH:mm');
  }

  return format(dateWithTimeDiff, 'ddd DD.MM.YY [at] HH:mm');
};

const getDateAsArray = function(date, timeZoneDiff, prefix, simpleView, originalDate) {
  const dateArray = [];
  let index = 0;

  if (simpleView) {
    dateArray.push(<span key={index++}>{format(date, 'DD.MM.YY HH:mm')}</span>);
  } else {
    //   dateArray.push(
    //     <span key={index++} className="day">
    //       {format(date, 'ddd')}
    //     </span>
    //   );
    dateArray.push(
      <span key={index++} className="date" data-date={originalDate}>
        {format(date, 'DD.MM.YY')}
      </span>
    );
    dateArray.push(
      <span key={index++} className="time">
        {format(date, '[at] HH:mm')}
      </span>
    );

    if (prefix) {
      dateArray.push(
        <span key={index++} className={`prefix`}>
          {`(${prefix})`}
        </span>
      );
    }
  }

  if (timeZoneDiff !== undefined) {
    dateArray.push(
      <span key={index++} className="timeZoneDiff">
        GMT {timeZoneDiff >= 0 ? `+${timeZoneDiff.toString()}` : timeZoneDiff.toString()}
      </span>
    );
  }

  return <span className="item__word__wrapper">{dateArray}</span>;
};

const getDateAsArrayMobile = function(date, prefix) {
  const dateArray = [];
  let index = 0;

  dateArray.push(
    <span key={index++} className="day">
      {format(date, 'dddd')}
    </span>
  );
  dateArray.push(
    <span key={index++} className="date">
      {format(date, 'DD.MM.YYYY')}
    </span>
  );
  dateArray.push(
    <span key={index++} className="time">
      {format(date, '[at] HH:mm')}
    </span>
  );

  //   if (prefix) {
  //     dateArray.push(
  //       <span key={index++} className={`prefix`}>
  //         {`(${prefix})`}
  //       </span>
  //     );
  //   }

  return <span className="item__word__wrapper">{dateArray}</span>;
};

const getDates = function(dateString, timeZoneDiff, prefix, showingGMT, simpleView) {
  if (dateString === undefined || dateString === null) {
    return null;
  }

  if (!timeZoneDiff || !isNumeric(timeZoneDiff)) {
    timeZoneDiff = 0;
  }

  const dateLocal = adjustForTimezoneAndRoundToHour(dateString, timeZoneDiff);
  const dateGMT = new Date(dateString);

  if (showingGMT) {
    return getDateAsArray(dateGMT, undefined, prefix, simpleView, dateString);
  } else {
    return getDateAsArray(dateLocal, timeZoneDiff, prefix, simpleView, dateString);
  }
};

const getDatesMobile = function(dateString, timeZoneDiff, prefix) {
  if (dateString === undefined || dateString === null) {
    return null;
  }

  if (!timeZoneDiff || !isNumeric(timeZoneDiff)) {
    timeZoneDiff = 0;
  }

  const dateLocal = adjustForTimezoneAndRoundToHour(dateString, timeZoneDiff);
  const dateGMT = new Date(dateString);

  return getDateAsArrayMobile(dateLocal, prefix);
};

export {
  updateItemWithCurrentPort,
  prepareCurrentPorts,
  createDescriptionString,
  getDateAsArray,
  getDateAsString,
  getDates,
  getDatesMobile,
  adjustForTimezoneAndRoundToHour,
  getCurrentPort
};



// WEBPACK FOOTER //
// ./src/utilsVisits.js